// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Pbhn","list":"styles_list__BBy8T"};